import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A collection of assets related to Attain Partners Innovation.',
    name: 'Innovation Assets',
    partialId: PartialId.Standard.create('innovation_assets'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
